import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router'
import { provideHttpClient } from '@angular/common/http'
import { Home } from './pages/home/home'
import { Impressum } from './pages/impressum/impressum'
import { Datenschutz } from './pages/datenschutz/datenschutz'

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideHttpClient(),
    provideRouter([
      { path: '', component: Home },
      { path: 'impressum', component: Impressum },
      { path: 'datenschutz', component: Datenschutz },
    ]),
    
  ]
};
